import { useState, useEffect } from 'react';
import { useDashboardStats } from '@pantry/api-client';
import { Sidebar } from './sidebar';
import { Header } from './header';
import { AnnouncementBanner } from '../announcements';
import { TourProvider, TourPrompt } from '../onboarding';
import { useTourContext } from '../onboarding/useTourContext';
import { useSelectedHousehold } from '../../contexts/HouseholdContext';

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <TourProvider>
      <TourItemCountSync />
      <div className="flex min-h-screen">
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <div className="flex flex-1 flex-col">
          <Header onMenuClick={() => setSidebarOpen(true)} />
          <AnnouncementBanner />

          <main className="flex-1 overflow-auto bg-muted p-6">
            <div className="mx-auto max-w-6xl">{children}</div>
          </main>
        </div>
      </div>

      {/* Tour prompt dialog */}
      <TourPrompt />
    </TourProvider>
  );
}

/** Keeps TourContext.itemCount in sync with the real dashboard stats. */
function TourItemCountSync() {
  const { selectedHousehold } = useSelectedHousehold();
  const { setItemCount } = useTourContext();
  const { data: stats } = useDashboardStats(selectedHousehold?.id ?? '');

  useEffect(() => {
    if (stats?.totalItems !== undefined) {
      setItemCount(stats.totalItems);
    }
  }, [stats?.totalItems, setItemCount]);

  return null;
}
